<template>
  <div class='container'>
    <div class='row'>
      <div 
        class="col-md-4 col-lg-3 d-md-block"
        :class='showCatgCls'
      >
        <div class="catg-container">
          <h5>Categories List</h5>
          <el-menu
            :default-active="selected"
            class="el-menu-demo"
            mode="vertical"
            router
            @select="handleSelect"
          >
            <perfect-scrollbar style='height: calc(100vh - 200px)' ref='playlistScroll2'>
              <el-menu-item 
                index='/live/ALL'
              >
                {{ 'All' }}
              </el-menu-item>
              <el-menu-item 
                v-for='(category, i) in categories'
                :key='i'
                :index='$router.resolve({name: "live.home.list", params: {category: category.title}}).route.path'
              >
                {{ category.title }}
              </el-menu-item>
            </perfect-scrollbar>
          </el-menu>
        </div>
      </div>
      <div class="col-md-8 col-lg-9 d-md-block"
        :class='showListCls'
      >
        <el-button
          type='primary'
          icon='el-icon-arrow-left'
          class='w-100 mb-3 d-md-none'
          @click='isHideList = true'
        >
          Back to categories
        </el-button>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { getAppResource } from '../../../app/helpers';
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

export default {
  name: 'LiveHome',
  components: {
    PerfectScrollbar,
  },
  data: () => ({
    categories: [],
    isHideList: false,
  }),
  computed: {
    selected() {
      const category = this.$route.params.category;

      return category 
        ? this.$router.resolve({
            name: "live.home.list", 
            params: {category}
          }).route.path
        : '/live/ALL';
    },

    showCatgCls() {
      if (this.isHideList) {
        return `d-block`
      }

      return ' d-none';
    },

    showListCls() {
      if (this.isHideList) {
        return `d-none`
      }

      return ' d-block';
    }
  },
  mounted() {
    this.getCategories();
  },
  methods: {
    async getCategories() {
      const categories = await getAppResource('channel-categories');

      if (categories) {
        const catgs = [];
        
        for (const c in categories) {
          catgs.push({
            title: categories[c].title,
            url: this.$router.resolve({
              name: 'live.search',
              query: {
                category: categories[c].title
              }
            }).route.fullPath,
          });
        }

        this.categories = catgs;
      }
    },

    handleSelect(item) {
      this.isHideList = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.catg-container {
    background: #1f1f1f;
}

ul.el-menu-demo.el-menu {
    background: transparent;
    border: none;
}

li.el-menu-item.is-active {
    background-color: #C70C13;
    color: white;
}

.catg-container h5 {
    color: #797979;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 20px 20px;
    margin-bottom: 0;
    background: #0e0e0e;
    border-bottom: 2px solid #010101;
}

.catg-container ::v-deep .ps__rail-y {
    z-index: 1;
}

li.el-menu-item {
    border-bottom: 1px solid #131212;
}


</style>